import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { applyKeyframe, mediaQuery, stack, theme } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { spacing } = theme;

export const loadPreviousWrapper = css`
  grid-column: 1 / -1;
  text-align: center;
`;

export const loadPreviousButton = css`
  margin-bottom: 0;
`;

export const paginationWrapper = css`
  grid-column: 1 / -1;
  text-align: center;
`;

export const progressBar = css`
  width: 11.25rem;
`;

export const productCardGridItem = css`
  grid-column: auto / span 6;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: auto / span 4;
    `,
  )};
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const productPage = css`
  margin: ${stack(spacing.xl)};
`;

export const fadeIn = css`
  animation: ${applyKeyframe(fadeInAnimation)} 400ms linear;
`;
